import {Pipe,PipeTransform} from '@angular/core';

@Pipe({
    name:'DynamicWorkoutListSvgPipe',
    pure:true
})

export class DynamicWorkoutListSvgPipe implements PipeTransform {
	transform(workout:any):string{
		let mediaSource = workout.mediaSource;
		let pngName = mediaSource.imageSource;
        let svgImg = "Icon_Time_L";
		if(pngName == 'ico_goal_adaptivepower.png') {
			svgImg = "Icon_Level_Resistance_L";
		}else if(pngName == 'ico_goal_aerobics.png') {
			svgImg = "Icon_Workout_L";
		}else if(pngName == 'ico_goal_constantpower.png') {
			svgImg = "Icon_Watts_L";
		}else if(pngName == 'ico_goal_mets.png') {
			svgImg = "Icon_Mets_L";
		}else if(pngName == 'ico_goal_migrosintervals.png') {
			svgImg = "Icon_Tread_Hill_1_to_1_L";
		}else if(pngName == 'ico_goal_reverse.png') {
			svgImg = "Icon_Workout_L";
		}else if(pngName == 'ico_goal_pace.png') {
			svgImg = "Icon_Pace_L";
		}else if(pngName == 'ico_goal_watts.png') {
			svgImg = "Icon_Watts_L";
		}else if(pngName == 'ico_goal_time.png') {
			svgImg = "Icon_Time_L";
		}else if(pngName == 'ico_goal_distance.png') {
			svgImg = "Icon_Distance_L";
		}else if(pngName == 'ico_goal_calories.png') {
			svgImg = "Icon_Calories_L";
		}else if(pngName == 'ico_goal_heartrate.png') {
			svgImg = "Icon_Cardio_Heartrate_L";
		}else if(pngName == 'ico_goal_climb.png') {
			svgImg = "Icon_Steps_L";
		}else if(pngName == 'ico_goal_intervals.png') {
			svgImg = "Icon_Tread_Hill_1_to_1_L";
		}else if(pngName == 'RandomMiniProfile.png') {
			svgImg = "Icon_Random_L";
		}else if(pngName == 'HRIntervalProfile.png') {
			svgImg = "Icon_Cardio_Interval_L";
		}else if(pngName == 'Adv_CYO_CustomSpeed.png') {
			svgImg = "Icon_Strength_Interval_L";
		}else if(pngName == 'ManualMiniProfile.png') {
			svgImg = "Icon_Manual_L";
		}else if(pngName == 'HillMiniProfile.png') {
			svgImg = "Icon_Hills_1_to_2_L";
		}else if(pngName == 'Adv_CYO.png') {
			svgImg = "Icon_Strength_Interval_L";
		}else if(pngName == 'Adv_CYO_CustomHR.png') {
			svgImg = "Icon_Rollers_1_L";
		}else if(pngName == 'CascadesProfile.png') {
			svgImg = "Icon_Speed_Bump_L";
		}else if(pngName == 'FoothillsProfile.png') {
			svgImg = "Icon_Rollers_2_L";
		}else if(pngName == 'KilimanjaroProfile.png') {
			svgImg = "Icon_Wave_L";
		}else if(pngName == 'Adv_CYO_HR.png') {
			svgImg = "Icon_Cardio_Interval_L";
		}else if(pngName == 'Adv_CYO_Speed.png') {
			svgImg = "Icon_Cardio_Interval_L";
		}else if(pngName == 'Adv_FitTests.png') {
			svgImg = "Icon_Manual_L";
		}else if(pngName == 'Adv_SportTrain.png') {
			svgImg = "Icon_Burst_L";
		}else if(pngName == 'Adv_SportTrain_5k.png') {
			svgImg = "Icon_Burst_L";
		}else if(pngName == 'Adv_SportTrain_Speed.png') {
			svgImg = "Icon_Cardio_Interval_L";
		}else if(pngName == 'ExtremeHRProfile.png') {
			svgImg = "Icon_Tread_Hill_1_to_1_L";
		}else if(pngName == 'FatBurnMiniProfile.png') {
			svgImg = "Icon_Rollers_1_L";
		}else if(pngName == 'HRHillProfile.png') {
			svgImg = "Icon_Cardio_Interval_L";
		}else if(pngName == 'ManualMiniProfile.png') {
			svgImg = "Icon_Manual_L";
		}else if(pngName == 'MiniProfile.png') {
			svgImg = "Icon_Manual_L";
		}else if(pngName == 'SportTrainingProfile.png') {
			svgImg = "Icon_Burst_L";			
		}
        return svgImg;
    }
}